import React, { useCallback, useEffect, useMemo, useRef } from "react";
// import { useNavigate } from "react-router-dom";
import { useSDK } from "./sdk";
import { useStore } from "./store";
import {
	Symbology,
} from "scandit-web-datacapture-barcode";
import styles from '../styles/BarcodeScanner.module.scss';

export default function ScannerComponent(props) {
const host = useRef(null);
const { loaded, loading, sdk } = useSDK();
const { setBarcode, keepCameraOn } = useStore();
//   const navigate = useNavigate();

const shouldKeepCameraOn = useCallback(async () => {
	if (!keepCameraOn) {
		await sdk.enableCamera(false);
	}
}, [sdk, keepCameraOn]);

const onScan = useMemo(
() => ({
	didScan: async (_, session) => {
	if (session.newlyRecognizedBarcodes.length > 0) {
		setBarcode();
		props.setBarcode();
		props.setScanFlg(true);
		await sdk.enableScanning(false);
		await shouldKeepCameraOn();
		// setBarcode(session.newlyRecognizedBarcodes[0]);

		// console.log("-------------------------");
		// console.log("【recognizedBarcodes】");
		// console.log("barcodes._symbology: "+session.newlyRecognizedBarcodes[0]._symbology);
		// console.log("barcodes._data: "+session.newlyRecognizedBarcodes[0]._data);
		// console.log("-------------------------");

		// const addOnData = session.newlyRecognizedBarcodes[0].addOnData;
		// if (addOnData) { //addonあり
		// 	console.log("barcodes.addOnData: "+addOnData);
		// }
		// if(addOnData != null){ //雑誌コード13桁 + addon5桁
		// 	setBarcode(session.newlyRecognizedBarcodes[0]._data + addOnData);
		// 	props.setBarcode(session.newlyRecognizedBarcodes[0]._data + addOnData);
		// 	// shoppingPurchaseAPI(session.newlyRecognizedBarcodes[0]._data + addOnData,ShoppingStartContext.data.token);
		// }else{
		// 	setBarcode(session.newlyRecognizedBarcodes[0]._data);
		// 	props.setBarcode(session.newlyRecognizedBarcodes[0]._data);
		// 	// shoppingPurchaseAPI(session.newlyRecognizedBarcodes[0]._data,ShoppingStartContext.data.token);
		// }

		const barcode = session.newlyRecognizedBarcodes[0];
		// const symbology = new barcode.SymbologyDescription(barcode.symbology);
		const symbology = barcode.symbology;
		const data = barcode.data;
		const addOnData = barcode.addOnData;

		console.log("-------------------------");
		console.log("【newlyRecognizedBarcodes】");
		console.log("symbology: " + symbology);
		console.log("data: " + data);
		console.log("-------------------------");

		// const addOnData = session.newlyRecognizedBarcodes[0].addOnData;
		if (addOnData) { //addonあり
			console.log("addOnData: "+addOnData);
			console.log("-------------------------");
			setBarcode(data + addOnData);
			props.setBarcode(data + addOnData);
			// shoppingPurchaseAPI(session.newlyRecognizedBarcodes[0]._data + addOnData,ShoppingStartContext.data.token);
		}else{
			setBarcode(data);
			props.setBarcode(data);
			// shoppingPurchaseAPI(session.newlyRecognizedBarcodes[0]._data,ShoppingStartContext.data.token);
		}

	//   navigate("/result");
	}
	},
}),
// [setBarcode, sdk, navigate, shouldKeepCameraOn]
[setBarcode, sdk, shouldKeepCameraOn]
);


useEffect(() => {

if(loaded){
	console.log("scandit sdk: " + "loaded");
}else if(loading){
	console.log("scandit sdk: " + "loading");
}

async function onMount() {
	if (loaded && host.current) {
	sdk.connectToElement(host.current);
	// await sdk.enableCamera(true);
	await sdk.enableCamera(true).catch((error) => {
		if (error) {
			// modify the styling so that scanner component is
			// on top of the view stack
			// alert(error);
			// console.error("Failed to switch camera state:", error);
			// setError(error);
		}
	});
	await sdk.enableScanning(true);
	await sdk.enableSymbology(Symbology.Code128,true);
	await sdk.enableSymbology(Symbology.EAN8,true);
	await sdk.enableSymbology(Symbology.EAN13UPCA,true);
	await sdk.enableSymbology(Symbology.UPCE,true);
	await sdk.enableSymbology(Symbology.QR,false);
	sdk.addBarcodeCaptureListener(onScan);
	}
}
onMount();

return () => {
	if (loaded) {
	sdk.removeBarcodeCaptureListener(onScan);
	sdk.detachFromElement();
	}
};
}, [loaded, loading, sdk, onScan]);

return <div ref={host} className={styles.scanImg} />;
}
